import { css } from 'linaria';

export const guaranteeGoods = css`
  margin-bottom: 4px;
`;

export const guaranteeModalSubtitle = css`
  padding-bottom: 8px;
  padding-left: 0;
`;

export const guaranteeModalList = css`
  li:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const guaranteeModalContent = css`
  && {
    margin-bottom: 40px;

    @media (--only-mobile) {
      margin-bottom: 32px;
    }
  }
`;
